import callApi from '../../util/apiCaller';

export const NOMINATION_LOAD_PROGRAMS = 'NOMINATION_LOAD_PROGRAMS';
export const NOMINATION_TOGGLE_PRODUCT_MAPPING = 'NOMINATION_TOGGLE_PRODUCT_MAPPING';
export const NOMINATION_LOAD_CLIENT_INITIATIVES = 'NOMINATION_LOAD_CLIENT_INITIATIVES';


let fetchProgramPromise = null;
export function fetchPrograms() {
  return (dispatch) => {
    if (fetchProgramPromise === null) {
      dispatch({
        type: NOMINATION_LOAD_PROGRAMS, programs: {}, status: 'loading', errors: null,
      });
      fetchProgramPromise = callApi('auth/programs', 'GET');
    }
    fetchProgramPromise.then(
      res => dispatch({
        type: NOMINATION_LOAD_PROGRAMS, programs: res.programs, status: 'loaded', errors: null,
      }),
      errors => dispatch({
        type: NOMINATION_LOAD_PROGRAMS, programs: {}, status: 'error', errors,
      }),
    );
    return fetchProgramPromise;
  };
}
export function resetTVPrograms() {
  return (dispatch) => {
    fetchProgramPromise = null;
    dispatch({
      type: NOMINATION_LOAD_PROGRAMS,
      programs: {},
      status: null,
      errors: null,
    });
  };
}

export function nominationToggleProductMapping(initiativeId, clientId, tvProductId, tsProductId) {
  return dispatch => dispatch({
    type: NOMINATION_TOGGLE_PRODUCT_MAPPING,
    initiativeId,
    clientId,
    tvProductId,
    tsProductId,
  });
}


export function fetchClientInitiatives(clientId, initiativeId) {
  return (dispatch) => {
    dispatch({
      type: NOMINATION_LOAD_CLIENT_INITIATIVES, initiatives: null, clientId, initiativeId,
    }); // to reset
    return callApi(`truvoice/clients/${clientId}/initiatives/${initiativeId}`, 'GET').then(
      res => dispatch({
        type: NOMINATION_LOAD_CLIENT_INITIATIVES, initiatives: res, clientId, initiativeId,
      }),
      () => dispatch({
        type: NOMINATION_LOAD_CLIENT_INITIATIVES, initiatives: null, clientId, initiativeId,
      }),
    );
  };
}
